import React, { Component } from 'react'
import { Button, Grid, ListItem, Paper, Typography } from '@material-ui/core'
import { EditableSwitch } from '../common/EditableComponents'
import { WmDispatchLogo } from '../../assets'

class WmDispatchDefaultSettingsTab extends Component {
  constructor(props) {
    super(props)
    this.state = {
      editMode: false,
      enableIntegration: false,
      enableExposeSales: false,
      enableExposeMember: false,
      codePreviewOpen: false,
      copied: false,
    }
  }

  onChange = (key, value, isSelect) => (e) => {
    if (isSelect) {
      this.setState({ [key]: e.target.value })
    } else {
      this.setState({ [key]: !value })
    }
  }

  toggleEdit = () => {
    this.setState({
      editMode: !this.state.editMode,
      enableIntegration: false,
      enableExposeSales: false,
      enableExposeMember: false,
      codePreviewOpen: false,
      copied: false,
    })

    this.setState((prevState) => ({
      codePreviewOpen: !prevState.codePreviewOpen,
    }))
  }

  onUpdate = () => {
    /* this.props.dispatch(updateShop(shop)).then(res => {
                this.toggleEdit()
            }) */
  }

  render() {
    const { editMode, enableIntegration, enableExposeSales, enableExposeMember } = this.state
    return (
      <div style={{ marginTop: '15px' }}>
        <Typography variant="title">Integration Details</Typography>
        <Paper elevation={0} className={`tab-paper`}>
          <Grid container>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              {!editMode ? (
                <Button className="primary-button pull-right btn-border" onClick={this.toggleEdit}>
                  {' '}
                  Edit{' '}
                </Button>
              ) : (
                <div className="pull-right margin-bottom-small">
                  <Button className="primary-button margin btn-border" onClick={this.onUpdate}>
                    Save
                  </Button>
                  <Button className="danger-button margin btn-border" onClick={this.toggleEdit}>
                    Cancel
                  </Button>
                </div>
              )}
            </Grid>
          </Grid>
          <Grid container className="listing-spacing">
            <ListItem>
              <Grid container>
                <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                  <img src={WmDispatchLogo} height={60} width={30} />
                </Grid>
                <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                  <div>
                    <b>Status:</b>
                  </div>
                  <div>Disconnected</div>
                </Grid>
              </Grid>
            </ListItem>
            <ListItem>
              <Grid container>
                <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>Enable Integration</Typography>
                </Grid>
                <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>
                    <EditableSwitch
                      checked={enableIntegration}
                      onChange={this.onChange('enableIntegration', enableIntegration)}
                      valueToRender={enableIntegration ? 'Enabled' : 'Disabled'}
                      editMode={editMode}
                    />
                  </Typography>
                </Grid>
              </Grid>
            </ListItem>
            <ListItem>
              <Grid container>
                <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>Expose Sales</Typography>
                </Grid>
                <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>
                    <EditableSwitch
                      checked={enableExposeSales}
                      onChange={this.onChange('enableExposeSales', enableExposeSales)}
                      valueToRender={enableExposeSales ? 'Enabled' : 'Disabled'}
                      editMode={editMode}
                    />
                  </Typography>
                </Grid>
              </Grid>
            </ListItem>
            <ListItem>
              <Grid container>
                <Grid className="labelField txt-bold" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>Expose Member</Typography>
                </Grid>
                <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                  <Typography>
                    <EditableSwitch
                      checked={enableExposeMember}
                      onChange={this.onChange('enableExposeMember', enableExposeMember)}
                      valueToRender={enableExposeMember ? 'Enabled' : 'Disabled'}
                      editMode={editMode}
                    />
                  </Typography>
                </Grid>
              </Grid>
            </ListItem>
          </Grid>
        </Paper>
      </div>
    )
  }
}

export default WmDispatchDefaultSettingsTab



// WEBPACK FOOTER //
// ./src/components/WmDispatch/WmDispatchDefaultSettingsTab.js